import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
} from "@chakra-ui/react";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";
import AddRemarkModal from "./AddRemarkModal";
import { FaTrash } from "react-icons/fa";

export default function RemarksModal({ isOpen, onClose, userId, peoples, fetchMarksData }) {
  const [remarks, setRemarks] = useState([]);
  const { isOpen: isAddRemarkOpen, onOpen: onAddRemarkOpen, onClose: onAddRemarkClose } = useDisclosure();

  const fetchRemarks = () => {
    console.log(userId);
    axios
      .get(`${apiUrl}/data/school/company/remarks/${userId}`, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setRemarks(response.data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas pobierania uwag");
      });
  };

  useEffect(() => {
    if (isOpen) {
      fetchRemarks();
    }
  }, [isOpen]);

  const handleDeleteRemark = (remarkId) => {
    axios
      .delete(`${apiUrl}/data/school/company/remarks/${remarkId}`, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        toast.success("Pomyślnie usunięto uwagę");
        fetchMarksData()
        fetchRemarks();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas usuwania uwagi");
      });
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Uwagi użytkownika</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap="4">
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Typ</Th>
                    <Th>Dodane przez</Th>
                    <Th>Opis</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {remarks.map((remark, index) => (
                    <Tr key={index}>
                      <Td>{remark.type === 1 ? "Pozytywna" : "Negatywna"}</Td>
                      <Td>
                        {
                          peoples.find(
                            (people) => people.value === remark.addedBy
                          )?.label
                        }
                      </Td>
                      <Td>{remark.content}</Td>
                      {(remark.addedBy == localStorage.getItem("id") || localStorage.getItem("roles").includes("973337145844584538") ||
            localStorage.getItem("roles").includes("973342432446009344") ||
            localStorage.getItem("roles").includes("973342432659914823") ||
            localStorage.getItem("roles").includes("1190995987154616381")) && (
                      <Td>
                        <Button colorScheme="red" onClick={() => handleDeleteRemark(remark.id)} size="sm">
                          <FaTrash />
                        </Button>
                      </Td>
                      )}
                    </Tr>
                  ))}
                </Tbody>
              </Table>
              <Button colorScheme="green" onClick={onAddRemarkOpen}>
                Dodaj uwagę
              </Button>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Zamknij
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <AddRemarkModal
        isOpen={isAddRemarkOpen}
        onClose={onAddRemarkClose}
        userId={userId}
        fetchRemarks={fetchRemarks}
        fetchMarksData={fetchMarksData}
      />
    </>
  );
}